export default "__VITE_ASSET__pOb3JM$f__"